import { createApp, defineAsyncComponent } from 'vue';

import '@/css/app.scss';
import "@/js/utils/whatsapp-deobfuscator.ts";
import { createAppI18n } from "./config/i18n.js";
import { useOrejime } from "@/vue/composables/useOrejime";
import {deobfuscateWhatsAppLinks} from "./utils/whatsapp-deobfuscator.ts";

// Lazy-loaded components
const CmbvlMap = defineAsyncComponent(() => import("@/vue/CmbvlMap.vue"));
const ResponsiveMenu = defineAsyncComponent(() => import("@/vue/ResponsiveMenu.vue"));
const Accordion = defineAsyncComponent(() => import("@/vue/Accordion.vue"));
const CsrfInput = defineAsyncComponent(() => import("@/vue/CsrfInput.vue"));
const FlashMessage = defineAsyncComponent(() => import("@/vue/FlashMessage.vue"));
const Carrousel = defineAsyncComponent(() => import("@/vue/Carrousel.vue"));
const NewsletterSubscriptionForm = defineAsyncComponent(() => import("@/vue/NewsletterSubscriptionForm.vue"));
const CustomizableMap = defineAsyncComponent(() => import("@/vue/CustomizableMap.vue"));
const FizSubscriptionForm = defineAsyncComponent(() => import("@/vue/FizSubscriptionForm.vue"));
const MissingAttachmentsPage = defineAsyncComponent(() => import("@/vue/FizMissingAttachmentsPage.vue"));
const PassyViteUploadTrackForm = defineAsyncComponent(() => import("@/vue/PassyViteUploadTrackForm.vue"));
const LightSwitch = defineAsyncComponent(() => import("@/vue/LightSwitch.vue"));
const FileUpload = defineAsyncComponent(() => import("@/vue/FileUpload.vue"));
const XcTaskMapWrapper = defineAsyncComponent(() => import("@/vue/XcTaskMapWrapper.vue"));
const CookieConsented = defineAsyncComponent(() => import("@/vue/CookieConsented.vue"));

// App main
const main = async () => {
  useOrejime();

  const i18n = await createAppI18n();

  // Create our vue instance
  const app = createApp({
    name: 'App',
    template: '#vue-root-template',
    components: {
      CmbvlMap,
      ResponsiveMenu,
      Accordion,
      FlashMessage,
      CsrfInput,
      Carrousel,
      NewsletterSubscriptionForm,
      CustomizableMap,
      FizSubscriptionForm,
      MissingAttachmentsPage,
      PassyViteUploadTrackForm,
      LightSwitch,
      FileUpload,
      XcTaskMapWrapper,
      CookieConsented,
    },
  });

  app.use(i18n);

  // Mount the app
  return app.mount('#vue-root');
};

// Execute async function
main().then(() => {
  deobfuscateWhatsAppLinks();
});

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept();
}
